import { render } from "./SubscribeWindow.vue?vue&type=template&id=bffeb562&scoped=true"
import script from "./SubscribeWindow.vue?vue&type=script&lang=js"
export * from "./SubscribeWindow.vue?vue&type=script&lang=js"

import "./SubscribeWindow.vue?vue&type=style&index=0&id=bffeb562&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffeb562"]])

export default __exports__